import http from "infra/http";
import { useMutation } from "react-query";

function useToggleParceiroStatus() {
  return useMutation(
    "/v1/parceiro/mudar-status",
    async (params: { id: string; nextStatus: boolean }) =>
      http.put(
        `/v1/parceiro/${params.id}/${
          params.nextStatus ? "ativar" : "desativar"
        }`
      )
  );
}

export default useToggleParceiroStatus;
